import * as React from 'react';
import {Company, Person} from "../../store/common-values/commonTypes";
import LinkWithDetails from "./LinkWithDetails";
import {DialogActions, DialogContent, DialogTitle} from "@mui/material";

export interface PersonInfoProps {
    person: Person;
}

export default function (props: PersonInfoProps) {
    const {person} = props;

    return (
        <React.Fragment>
            <LinkWithDetails text={person?.fullName} title={"Kontaktperson Detaljer"}>
                <DialogContent>
                    <div className="col-sm-12 mb-3">
                        <div>
                            <span className="label">Fornavn:</span>
                        </div>
                        <div>
                            <span className="data-value">{person.firstName || 'Ikke spesifisert'}</span>
                        </div>
                    </div>
                    <div className="col-sm-12 mb-3">
                        <div>
                            <span className="label">Etternavn:</span>
                        </div>
                        <div>
                            <span className="data-value">{person.lastName || 'Ikke spesifisert'}</span>
                        </div>
                    </div>
                    <div className="col-sm-12 mb-3">
                        <div>
                            <span className="label">E-post:</span>
                        </div>
                        <div>
                            <span className="data-value">{person.email ? <a href={`mailto:${person.email}`}>{person.email}</a> : 'Ikke spesifisert'}</span>
                        </div>
                    </div>
                    <div className="col-sm-12 mb-3">
                        <div>
                            <span className="label">Telefon:</span>
                        </div>
                        <div>
                            <span className="data-value">{person.phone ? <a href={`tel:${person.phone}`}>{person.phone}</a> : 'Ikke spesifisert'}</span>
                        </div>
                    </div>
                </DialogContent>
            </LinkWithDetails>
        </React.Fragment>
    );
}
